export default "__VITE_ASSET__DPysJjvA__"